<div
  class="file-viewer"
  *ngIf="isImg || isPdf || unsuppFile"
  [class.show-image]="isImg"
  [class.show-pdf]="isPdf"
>

  <!-- HEADER -->
  <div class="viewer-header">

    <div class="close-icon-div">
      <span
        class="material-icons-outlined close-icon"
        (click)="close()"
        title="Close"
      >
        close
      </span>

      <mat-divider vertical></mat-divider>

      <span class="file-name" title="{{ selectedFile?.fileName }}">
        {{ selectedFile?.fileName }}
      </span>
    </div>

    <div class="viewer-actions">

      <button
        type="button"
        class="icon-btn rotate-btn"
        (click)="rotate()"
        title="Rotate image"
      >
        <mat-icon>rotate_left</mat-icon>
      </button>

      <button
        type="button"
        class="download-btn"
        (click)="downloadFile()"
      >
        Download
      </button>

    </div>

  </div>


  <!-- IMAGE VIEW -->
  <div class="image-container" *ngIf="isImg">
    <img
      [src]="isImg"
      [@rotatedState]="state"
      class="viewer-image"
      alt="Preview image"
    />
  </div>


  <!-- PDF VIEW -->
  <div class="pdf-container" *ngIf="isPdf">
    <pdf-viewer
      [src]="isPdf"
      [render-text]="true"
      [original-size]="false"
      [show-all]="true"
      [zoom]="1"
      style="display:block;width:100%;height:100%;">
    </pdf-viewer>
  </div>


  <!-- UNSUPPORTED -->
  <div *ngIf="unsuppFile" class="unsupported-file">
    {{ unsuppFile }}
  </div>

</div>
